var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestTabletLikeSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 9,
  viewBox: "0 0 9 9",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 3.12C0 1.396 1.188 0 2.516 0c1.327 0 1.966.924 1.966.924S5.122 0 6.448 0c1.328 0 2.516 1.397 2.516 3.12 0 1.722-2.073 3.995-4.482 5.238C2.073 7.115 0 4.842 0 3.12"
})));
export default SvgPinterestTabletLikeSm;